import type { ReactNode } from "react";
import type { SxProps, Theme } from "@mui/material/styles";
import { ListGridTemplate } from "@/components/list-grid/ListGridTemplate";

const AREAS = `'expand . sku . product . location . status . cin7 . threePl . difference .'`;
const COLUMNS = "32px 12px 168px 12px minmax(200px, 1fr) 12px minmax(180px, 0.6fr) 12px 160px 12px 88px 12px 136px 12px 88px 16px";

interface InventoryListTemplateProps {
  children: ReactNode;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

/** The grid every inventory list row and its headings are laid out on; cells place themselves by gridArea name. */
export const InventoryListTemplate = (props: InventoryListTemplateProps) => {
  const { children, onClick, sx } = props;

  return (
    <ListGridTemplate
      areas={AREAS}
      columns={COLUMNS}
      onClick={onClick}
      sx={sx}
    >
      {children}
    </ListGridTemplate>
  );
};
